import { render } from "./HealthCheck.vue?vue&type=template&id=74daeb82&scoped=true"
import script from "./HealthCheck.vue?vue&type=script&lang=js"
export * from "./HealthCheck.vue?vue&type=script&lang=js"

import "./HealthCheck.vue?vue&type=style&index=0&id=74daeb82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74daeb82"]])

export default __exports__